/* ============================================================
   Routine Builder — LAO Care
   Custom element <routine-builder>
   ============================================================ */
(function () {
  'use strict';

  /* ---- money formatting (Shopify standard) ---- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || '€{{amount}}';

    function defaultTo(num, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(num) || num == null) return 0;
      num = (num / 100.0).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cts = parts[1] ? decimal + parts[1] : '';
      return dollars + cts;
    }

    switch ((fmt.match(placeholderRegex) || [])[1]) {
      case 'amount': value = defaultTo(cents, 2); break;
      case 'amount_no_decimals': value = defaultTo(cents, 0); break;
      case 'amount_with_comma_separator': value = defaultTo(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = defaultTo(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = defaultTo(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = defaultTo(cents, 0, ' ', ''); break;
      default: value = defaultTo(cents, 2);
    }
    return fmt.replace(placeholderRegex, value);
  }

  var SILHOUETTE = '<svg viewBox="0 0 40 40" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M15 4h10l2 6-2 2v18a3 3 0 0 1-3 3h-4a3 3 0 0 1-3-3V12l-2-2 2-6z"/></svg>';

  // Per-step placeholder silhouettes (shadow) shown in empty recap slots
  var RB_ICONS = {
    shampoo: '<svg viewBox="0 0 40 40" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><rect x="18" y="3" width="4" height="3" rx="1"/><rect x="19.2" y="5" width="1.6" height="3"/><rect x="15" y="6" width="3.4" height="2.2" rx="1"/><rect x="16" y="8" width="8" height="3" rx="1.2"/><path d="M15.5 11h9v20a3 3 0 0 1-3 3h-3a3 3 0 0 1-3-3V11z"/></svg>',
    tube: '<svg viewBox="0 0 40 40" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><rect x="17" y="4" width="6" height="3.4" rx="1.4"/><path d="M16 7.4h8v21.6a2.2 2.2 0 0 1-2.2 2.2h-3.6A2.2 2.2 0 0 1 16 29z"/><path d="M16 31.2h8l-1.2 3.8h-5.6z"/></svg>',
    cream: '<svg viewBox="0 0 40 40" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><rect x="18" y="4" width="4" height="3" rx="1"/><rect x="14.5" y="6" width="3.6" height="2.2" rx="1"/><rect x="15" y="8.2" width="10" height="3" rx="1.2"/><path d="M14.5 11.2h11v18.8a3 3 0 0 1-3 3h-5a3 3 0 0 1-3-3V11.2z"/></svg>',
    comb: '<svg viewBox="0 0 40 40" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><rect x="8" y="11" width="24" height="6" rx="2"/><rect x="10" y="17" width="2.6" height="10" rx="1"/><rect x="15" y="17" width="2.6" height="10" rx="1"/><rect x="20" y="17" width="2.6" height="10" rx="1"/><rect x="25" y="17" width="2.6" height="10" rx="1"/></svg>'
  };
  function rbIconFor(name) {
    name = (name || '').toLowerCase();
    if (name.indexOf('accessoire') > -1 || name.indexOf('peigne') > -1) return RB_ICONS.comb;
    if (name.indexOf('coiffage') > -1 || name.indexOf('finition') > -1 || name.indexOf('crème') > -1 || name.indexOf('creme') > -1) return RB_ICONS.cream;
    if (name.indexOf('soin') > -1 || name.indexOf('démêl') > -1 || name.indexOf('demel') > -1) return RB_ICONS.tube;
    if (name.indexOf('lav') > -1 || name.indexOf('shampo') > -1) return RB_ICONS.shampoo;
    return SILHOUETTE;
  }

  if (customElements.get('routine-builder')) return;

  customElements.define('routine-builder', class extends HTMLElement {
    connectedCallback() {
      this.mode = this.getAttribute('data-mode') || 'full';
      if (this.mode !== 'full') return; // teaser: nothing to wire

      this.minProducts = parseInt(this.getAttribute('data-min'), 10) || 3;
      this.moneyFormat = this.getAttribute('data-money-format') || '€{{amount}}';
      try { this.tiers = JSON.parse(this.getAttribute('data-tiers') || '[]'); }
      catch (e) { this.tiers = []; }
      this.tiers.sort(function (a, b) { return a.q - b.q; });
      try { this.tierCodes = JSON.parse(this.getAttribute('data-tier-codes') || '{}'); }
      catch (e) { this.tierCodes = {}; }

      this.selection = new Map();

      this.cacheDom();
      this.bindEvents();
      this.render();
    }

    cacheDom() {
      this.profileScreen = this.querySelector('[data-rb-profile-screen]');
      this.builder = this.querySelector('[data-rb-builder]');
      this.profileNameEls = this.querySelectorAll('[data-rb-profile-name]');
      this.slotsEl = this.querySelector('[data-rb-slots]');
      this.steps = Array.prototype.slice.call(this.querySelectorAll('[data-rb-step]'));
      this.navBtns = Array.prototype.slice.call(this.querySelectorAll('[data-rb-step-link]'));
      this.products = Array.prototype.slice.call(this.querySelectorAll('[data-rb-product]'));
      this.tierFill = this.querySelector('[data-rb-tier-fill]');
      this.tierTicks = Array.prototype.slice.call(this.querySelectorAll('[data-rb-tier-tick]'));
      this.tierMsg = this.querySelector('[data-rb-tier-msg]');
      this.subtotalEl = this.querySelector('[data-rb-subtotal]');
      this.savingRow = this.querySelector('[data-rb-saving-row]');
      this.savingEl = this.querySelector('[data-rb-saving]');
      this.totalEl = this.querySelector('[data-rb-total]');
      this.strikeEl = this.querySelector('[data-rb-strike]');
      this.addBtn = this.querySelector('[data-rb-add]');
      this.hintEl = this.querySelector('[data-rb-hint]');
      this.mobileBar = this.querySelector('[data-rb-mobilebar]');
      this.mobileTotal = this.querySelector('[data-rb-mobile-total]');
      this.mobileInfo = this.querySelector('[data-rb-mobile-info]');
    }

    bindEvents() {
      var self = this;

      this.querySelectorAll('[data-rb-profile]').forEach(function (btn) {
        btn.addEventListener('click', function () { self.chooseProfile(btn); });
      });

      this.querySelectorAll('[data-rb-change-profile]').forEach(function (btn) {
        btn.addEventListener('click', function () { self.backToProfile(); });
      });

      this.navBtns.forEach(function (btn) {
        btn.addEventListener('click', function () { self.goToStep(btn.getAttribute('data-rb-step-link')); });
      });

      this.products.forEach(function (card) {
        if (card.getAttribute('data-rb-available') === '0') return; // produit épuisé : non sélectionnable
        var btn = card.querySelector('[data-rb-select]');
        var handler = function (e) { e.preventDefault(); self.toggleProduct(card); };
        if (btn) btn.addEventListener('click', handler);
        var media = card.querySelector('.rb-product__media');
        if (media) media.addEventListener('click', handler);

        var vsel = card.querySelector('[data-rb-variant]');
        if (vsel) {
          vsel.addEventListener('click', function (e) { e.stopPropagation(); });
          vsel.addEventListener('change', function () {
            var opt = vsel.options[vsel.selectedIndex];
            var oldId = card.getAttribute('data-id');
            card.setAttribute('data-id', vsel.value);
            card.setAttribute('data-price', opt.getAttribute('data-price') || card.getAttribute('data-price'));
            card.setAttribute('data-title', (card.getAttribute('data-title') || '').split(' — ')[0] + ' — ' + opt.textContent.trim());
            var priceEl = card.querySelector('.rb-product__price');
            if (priceEl && opt.getAttribute('data-price-formatted')) priceEl.textContent = opt.getAttribute('data-price-formatted');
            if (self.selection.has(oldId)) {
              self.selection.delete(oldId);
              self.toggleProduct(card);
            }
          });
        }
      });

      [this.addBtn, this.querySelector('[data-rb-mobile-add]')].forEach(function (btn) {
        if (btn) btn.addEventListener('click', function () { self.addToCart(); });
      });
    }

    chooseProfile(btn) {
      this.profileTag = (btn.getAttribute('data-rb-profile') || '').trim().toLowerCase();
      this.profileLabel = btn.getAttribute('data-rb-profile-label') || '';
      this.profileNameEls.forEach(function (el) { el.textContent = this.profileLabel; }, this);

      this.filterByProfile();
      this.profileScreen.hidden = true;
      this.builder.hidden = false;
      this.classList.add('rb--builder-active');
      var first = this.navBtns[0];
      if (first) this.goToStep(first.getAttribute('data-rb-step-link'));
      this.builder.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    backToProfile() {
      this.builder.hidden = true;
      this.profileScreen.hidden = false;
      this.classList.remove('rb--builder-active');
      this.profileScreen.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    filterByProfile() {
      var self = this;
      this.steps.forEach(function (stepEl) {
        var cards = Array.prototype.slice.call(stepEl.querySelectorAll('[data-rb-product]'));
        var anyMatch = false;
        if (self.profileTag) {
          anyMatch = cards.some(function (c) {
            return (c.getAttribute('data-tags') || '').split(',').indexOf(self.profileTag) !== -1;
          });
        }
        cards.forEach(function (c) {
          if (self.profileTag && anyMatch) {
            var has = (c.getAttribute('data-tags') || '').split(',').indexOf(self.profileTag) !== -1;
            c.hidden = !has;
          } else {
            c.hidden = false;
          }
        });
      });
    }

    goToStep(index) {
      this.steps.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-rb-step') === index); });
      var activeBtn = null;
      this.navBtns.forEach(function (b) {
        var on = b.getAttribute('data-rb-step-link') === index;
        b.classList.toggle('is-active', on);
        if (on) activeBtn = b;
      });
      // Recentre l'étape active dans la nav horizontale (révèle les étapes suivantes, ex. Accessoires)
      if (activeBtn) {
        var nav = activeBtn.closest('[data-rb-nav]') || activeBtn.parentNode;
        if (nav && nav.scrollWidth > nav.clientWidth) {
          var navRect = nav.getBoundingClientRect();
          var btnRect = activeBtn.getBoundingClientRect();
          var target = nav.scrollLeft + (btnRect.left - navRect.left) - (nav.clientWidth / 2) + (btnRect.width / 2);
          if (nav.scrollTo) { nav.scrollTo({ left: target, behavior: 'smooth' }); }
          else { nav.scrollLeft = target; }
        }
      }
      this.builder.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    toggleProduct(card) {
      if (card.getAttribute('data-rb-available') === '0') return; // sécurité : ne jamais sélectionner un produit épuisé
      var id = card.getAttribute('data-id');
      if (this.selection.has(id)) {
        this.selection.delete(id);
        card.classList.remove('is-selected');
      } else {
        this.selection.set(id, {
          id: id,
          title: card.getAttribute('data-title'),
          price: parseInt(card.getAttribute('data-price'), 10) || 0,
          image: card.getAttribute('data-image') || '',
          step: card.getAttribute('data-step'),
          stepName: card.getAttribute('data-step-name') || '',
          eligible: card.getAttribute('data-rb-eligible') === '1',
          qty: 1
        });
        card.classList.add('is-selected');
      }
      this.render();
    }

    removeProduct(id) {
      this.selection.delete(id);
      var card = this.products.filter(function (c) { return c.getAttribute('data-id') === id; })[0];
      if (card) card.classList.remove('is-selected');
      this.render();
    }

    setQty(id, delta) {
      var item = this.selection.get(id);
      if (!item) return;
      item.qty = Math.max(1, (item.qty || 1) + delta);
      this.render();
    }

    currentTier(count) {
      var disc = 0;
      for (var i = 0; i < this.tiers.length; i++) {
        if (count >= this.tiers[i].q) disc = this.tiers[i].d;
      }
      return disc;
    }

    nextTier(count) {
      for (var i = 0; i < this.tiers.length; i++) {
        if (count < this.tiers[i].q) return this.tiers[i];
      }
      return null;
    }

    render() {
      var self = this;
      var items = Array.from(this.selection.values());
      var totalCount = items.reduce(function (s, it) { return s + (it.qty || 1); }, 0);
      var subtotal = items.reduce(function (s, it) { return s + it.price * (it.qty || 1); }, 0);
      var eligItems = items.filter(function (it) { return it.eligible; });
      var eligCount = eligItems.reduce(function (s, it) { return s + (it.qty || 1); }, 0);
      var eligSubtotal = eligItems.reduce(function (s, it) { return s + it.price * (it.qty || 1); }, 0);
      var disc = this.currentTier(eligCount);
      var saving = Math.round(eligSubtotal * disc / 100);
      var total = subtotal - saving;

      if (this.slotsEl) {
        this.slotsEl.innerHTML = '';
        var bySlot = [];
        this.steps.forEach(function (stepEl) {
          var idx = stepEl.getAttribute('data-rb-step');
          var name = stepEl.getAttribute('data-rb-step-name') || '';
          var inStep = items.filter(function (it) { return it.step === idx; });
          if (inStep.length === 0) {
            bySlot.push({ name: name, item: null });
          } else {
            inStep.forEach(function (it) { bySlot.push({ name: name, item: it }); });
          }
        });
        bySlot.forEach(function (slot) {
          var div = document.createElement('div');
          div.className = 'rb-slot' + (slot.item ? ' is-filled' : '');
          if (slot.item) {
            var qty = slot.item.qty || 1;
            div.innerHTML =
              '<div class="rb-slot__thumb" style="background-image:url(' + slot.item.image + ')"></div>' +
              '<div class="rb-slot__qty">' +
                '<button type="button" class="rb-slot__qtybtn" aria-label="Diminuer la quantité" data-rb-qty-minus="' + slot.item.id + '"' + (qty <= 1 ? ' disabled' : '') + '>&minus;</button>' +
                '<span class="rb-slot__qtynum" aria-live="polite">' + qty + '</span>' +
                '<button type="button" class="rb-slot__qtybtn" aria-label="Augmenter la quantité" data-rb-qty-plus="' + slot.item.id + '">+</button>' +
              '</div>' +
              '<div class="rb-slot__body"><div class="rb-slot__step">' + slot.name + '</div>' +
              '<div class="rb-slot__name">' + slot.item.title + '</div></div>' +
              '<button type="button" class="rb-slot__remove" aria-label="Retirer" data-rb-remove="' + slot.item.id + '">&times;</button>';
          } else {
            div.innerHTML =
              '<div class="rb-slot__thumb">' + rbIconFor(slot.name) + '</div>' +
              '<div class="rb-slot__body"><div class="rb-slot__step">' + slot.name + '</div>' +
              '<div class="rb-slot__empty">À choisir</div></div>';
          }
          self.slotsEl.appendChild(div);
        });
        this.slotsEl.querySelectorAll('[data-rb-remove]').forEach(function (b) {
          b.addEventListener('click', function () { self.removeProduct(b.getAttribute('data-rb-remove')); });
        });
        this.slotsEl.querySelectorAll('[data-rb-qty-minus]').forEach(function (b) {
          b.addEventListener('click', function () { self.setQty(b.getAttribute('data-rb-qty-minus'), -1); });
        });
        this.slotsEl.querySelectorAll('[data-rb-qty-plus]').forEach(function (b) {
          b.addEventListener('click', function () { self.setQty(b.getAttribute('data-rb-qty-plus'), 1); });
        });
      }

      var maxQ = this.tiers.length ? this.tiers[this.tiers.length - 1].q : this.minProducts;
      if (this.tierFill) this.tierFill.style.width = Math.min(100, (eligCount / maxQ) * 100) + '%';
      this.tierTicks.forEach(function (t) {
        var q = parseInt(t.getAttribute('data-rb-tier-tick'), 10);
        t.classList.toggle('is-reached', eligCount >= q);
      });
      if (this.tierMsg) {
        var nt = this.nextTier(eligCount);
        if (totalCount < this.minProducts) {
          this.tierMsg.textContent = 'Ajoutez ' + (this.minProducts - totalCount) + ' produit' + (this.minProducts - totalCount > 1 ? 's' : '') + ' pour valider votre routine';
        } else if (nt) {
          this.tierMsg.textContent = 'Plus que ' + (nt.q - eligCount) + ' produit' + (nt.q - eligCount > 1 ? 's' : '') + ' pour ' + nt.d + '% de remise \u{1F389}';
        } else if (disc > 0) {
          this.tierMsg.textContent = 'Remise maximale de ' + disc + '% débloquée \u{1F389}';
        } else {
          this.tierMsg.textContent = '';
        }
      }

      if (this.subtotalEl) this.subtotalEl.textContent = formatMoney(subtotal, this.moneyFormat);
      if (this.savingRow) this.savingRow.hidden = saving <= 0;
      if (this.savingEl) this.savingEl.textContent = '-' + formatMoney(saving, this.moneyFormat) + ' (-' + disc + '%)';
      if (this.totalEl) this.totalEl.textContent = formatMoney(total, this.moneyFormat);
      if (this.strikeEl) { this.strikeEl.hidden = saving <= 0; this.strikeEl.textContent = formatMoney(subtotal, this.moneyFormat); }

      var ready = totalCount >= this.minProducts;
      if (this.addBtn) {
        this.addBtn.disabled = !ready;
        this.addBtn.textContent = ready ? 'Ajouter ma routine • ' + formatMoney(total, this.moneyFormat) : 'Ajouter ma routine';
      }
      if (this.hintEl) {
        this.hintEl.textContent = ready
          ? (disc > 0 ? 'Remise de ' + disc + '% appliquée automatiquement' : '')
          : 'Minimum ' + this.minProducts + ' produits pour composer une routine';
      }

      if (this.mobileBar) {
        this.mobileBar.classList.toggle('is-visible', totalCount > 0);
        if (this.mobileTotal) this.mobileTotal.textContent = formatMoney(total, this.moneyFormat);
        if (this.mobileInfo) this.mobileInfo.textContent = totalCount + ' produit' + (totalCount > 1 ? 's' : '') + (disc > 0 ? ' • -' + disc + '%' : '');
        var mAdd = this.querySelector('[data-rb-mobile-add]');
        if (mAdd) mAdd.disabled = !ready;
      }
    }

    addToCart() {
      var self = this;
      var items = Array.from(this.selection.values());
      var totalCount = items.reduce(function (s, it) { return s + (it.qty || 1); }, 0);
      if (totalCount < this.minProducts) return;

      var bundleId = 'routine-' + Date.now().toString(36);
      var payload = {
        items: items.map(function (it) {
          return {
            id: parseInt(it.id, 10),
            quantity: it.qty || 1,
            properties: {
              '_Routine sur-mesure': self.profileLabel || 'Oui',
              '_routine_bundle': bundleId
            }
          };
        })
      };

      if (this.addBtn) { this.addBtn.classList.add('is-loading'); this.addBtn.textContent = 'Ajout en cours…'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw e; });
          return r.json();
        })
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function (err) {
          if (self.addBtn) { self.addBtn.classList.remove('is-loading'); }
          self.render();
          if (self.hintEl) self.hintEl.textContent = (err && err.description) ? err.description : 'Une erreur est survenue, réessayez.';
          console.error('[routine-builder] add to cart failed', err);
        });
    }
  });
})();
